import { useRouteError } from "react-router-dom";
import EdHelmet from "../../components/edHelmet";

const PageError = () => {
    const error = useRouteError();
    console.error("Error Page", error);

    return (
        <div id="error-page">
            <EdHelmet title="Error" description="Oops! Sorry, an unexpected error has occurred." />
            <h1>Oops!</h1>
            <p>Sorry, an unexpected error has occurred.</p>
            <p>
                <i>{error.statusText || error.message}</i>
            </p>
        </div>
    );
}

export default PageError;